import Spinner from '@/components2/Spinner';
import React, { Suspense, useContext } from 'react';
import { MyComponentType } from './component-factory/component-types';
import { Props } from './editor/ComponentBasicRender';
import { PageEditorStoreContext } from './store/PageEditorStore';
import { ElementConfigType } from './store/type';
import { transformReactCSS } from './utils';
import { useBasicDrop } from './utils/useBasicDrop';

const ConfigHOC: (ConfigForm: React.FC) => React.FC = (ConfigForm) => {
  return (props) => {
    return (
      <Suspense fallback={<Spinner />}>{!process.env.__IS__SERVER__ ? <ConfigForm {...props} /> : <></>}</Suspense>
    );
  };
};

const WrapperHOC: (Wrapper: React.FC<ElementConfigType>) => React.FC<ElementConfigType> = (Wrapper) => {
  return (props) => {
    return <Suspense>{!process.env.__IS__SERVER__ ? <Wrapper {...props} /> : <></>}</Suspense>;
  };
};

const DroppableHOC: (Droppable: React.FC<Props>) => React.FC<Props> = (Droppable) => {
  return (props) => {
    return <Suspense>{!process.env.__IS__SERVER__ ? <Droppable {...props} /> : <></>}</Suspense>;
  };
};

const StylingHOC: (Component: MyComponentType<ElementConfigType> | undefined) => React.FC<ElementConfigType> = (
  Component,
) => {
  return (props) => {
    const {
      nodeId,
      composeStyle = [
        {
          id: `default_${nodeId}`,
          name: '默认规则',
          type: 'DEFAULT',
          minWidth: 0,
          maxWidth: 0,
          rules: {},
        },
      ],
    } = props;

    const id = `node_${nodeId}`;
    const partSelector = Component?.definition.isWebComponent ? Component.definition.partSelector : null;
    // const initStyle = Component?.definition.computeStyle ? Component?.definition.computeStyle(props) : styles;

    const stylesTags = [];
    if (Array.isArray(composeStyle)) {
      // const allStyleRules = new Array(composeStyle.length).fill([]);
      // if (allStyleRules.length !== 0) {
      //   allStyleRules[0] = [...transformReactCSS(initStyle)];
      // }
      // for (let i = 0; i < composeStyle.length; i++) {
      //   const styleItem = composeStyle[i];
      //   const CSSLines = allStyleRules[i];
      for (const styleItem of composeStyle) {
        const CSSLines = [];
        const needSuffixKeys = [
          'margin-top',
          'margin-right',
          'margin-bottom',
          'margin-left',
          'padding-top',
          'padding-right',
          'padding-bottom',
          'padding-left',
          'font-size',
          'line-height',
          'gap',
        ];
        for (const key in styleItem.rules) {
          if (styleItem.rules[key] !== '') {
            CSSLines.push(
              `${key}: ${styleItem.rules[key]}${
                needSuffixKeys.includes(key) && !String(styleItem.rules[key])?.includes('%') ? 'px' : ''
              };`,
            );
          }
        }
        stylesTags.push(
          <style key={styleItem.id}>
{`
            @media screen and (min-width: ${styleItem.minWidth || 0}px) ${
              styleItem.maxWidth ? ` and (max-width: ${styleItem.maxWidth}px)` : ''
            } {
              #${id}${partSelector ? `::part(${partSelector})` : ''} {
                ${CSSLines.join('\n')}
              }
            }
        
`}</style>,
        );
      }
    }

    return Component ? (
      <>
        {stylesTags}
        <Component id={id} {...props} />
      </>
    ) : (
      <p>渲染错误</p>
    );
  };
};

const DropContainer = (props: any) => {
  const { drop, currentStyle } = useBasicDrop(props);

  return (
    <div className="dropContainer h-full" ref={drop} style={currentStyle}>
      {props.children}
    </div>
  );
};

export const MultiContainerHOC: React.FC<Props> = (props: ElementConfigType, MultiComponent: React.FC<Props>) => {
  const pageEditorStore = useContext(PageEditorStoreContext);
  return (
    <>
      {pageEditorStore.isRenderHtml ? (
        <MultiComponent {...props} />
      ) : (
        <DropContainer {...props}>
          <MultiComponent {...props} />
        </DropContainer>
      )}
    </>
  );
};

export { ConfigHOC, WrapperHOC, DroppableHOC, StylingHOC, DropContainer };
